module.exports = __webpack_public_path__ + "media/images/gallery/dir_on-d7254b2e7e15d0e574b6e24194c430ab.gif";